import AlertPopup from "@/components/molecules/AlertPopup";
import { GlobalContext } from "@/contexts/SiteDataContext";
import dataLayer from "@/services/DataLayer";
import React, { useContext, useEffect } from "react";

const CLOSE_DATALAYER_KEY = "closePopupNotYourForm";
const REDIRECT_DATALAYER_KEY = "redirectToD11FromPopupNotYourForm";
const SHOWUP_DATALAYER_KEY = "showUpPopupNotYourForm";

interface Under16AlertProps {
  onClose?: () => void;
}

const Under16Alert = ({ onClose }: Under16AlertProps) => {
  const { t } = useContext(GlobalContext).context;
  const handleOnClose = () => {
    dataLayer.push(CLOSE_DATALAYER_KEY);
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const handleOnRedirect = () => {
    dataLayer.push(REDIRECT_DATALAYER_KEY);
  };

  useEffect(() => {
    dataLayer.push(SHOWUP_DATALAYER_KEY);
  }, []);

  return (
    <AlertPopup
      title={t["We noticed you’re under 16 years old and are applying for a passport renewal."]}
      alertMessage={
        t[
          "If however, you’ve entered the wrong date of birth by mistake simply correct the error and continue filling in the form as normal."
        ]
      }
      onClose={handleOnClose}
      content={
        <span
          dangerouslySetInnerHTML={{
            __html:
              t[
                "<b>Remember:</b> When you’re under 16 you must fill out a DS-11 new application even if this isn’t your first passport."
              ],
          }}
        />
      }
      redirect={{
        to: "/new-passport",
        label: t["Go to DS-11"],
        onClick: handleOnRedirect,
      }}
    />
  );
};

export default Under16Alert;
